module.exports = __webpack_public_path__ + "static/media/CrudOil.6ee2fa98.png";